<template>
  <div class="contractManagement-examine-bd">
    <custom-dialog v-drag-dialog :title="$t('dms_device_detail_openCard_changeUser.ggsyr')" :visible="visible" v-on="$listeners" width="400px">
      <div class="dialog-body">
        <el-form :model="form" :inline="true" ref="form" label-width="80px">
          <el-row>
            <el-form-item :label="$t('dms_device_detail_openCard_changeUser.shi_yong_ren')" prop="cardOwner" :rules="rules.cardOwner">
              <el-input v-model="form.cardOwner" style="width: 260px"></el-input>
            </el-form-item>
            <el-form-item :label="$t('dms_device_detail_openCard_changeUser.syrdh')" prop="cardOwnerPhone" :rules="rules.cardOwnerPhone">
              <el-input v-model="form.cardOwnerPhone" style="width: 260px"></el-input>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
        <el-button type="primary" @click="saveContact">{{ $t('Common.com_confirm') }}</el-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  props: ['value'],
  data() {
    return {
      visible: false,
      form: {
        cardOwner: '',
        cardOwnerPhone: '',
        deviceCardId: '',
      }
    };
  },
  computed: {
    rules() {
      return {
        cardOwner: [{ required: true, message: this.$t('dms_device_detail_openCard_changeUser.qsrsyr') }],
        cardOwnerPhone: [{ validator: null, message: this.$t('dms_device_detail_openCard_changeUser.cdyz713gzf') }],
      };
    },
  },
  mounted() {
    this.initDialog();
    this.formRule();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.form.deviceCardId = this.model.data.deviceCardId;
    },
    formRule: function () {
      this.rules.cardOwnerPhone[1].validator = this.$mobilePhoneValidator;
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 250);
    },
    // 确认保存分组
    saveContact: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        // bootCardChangeUserPwd
        if (this.model.type === 'password') {
          this.$postJSON(apis.bootCardChangeUserPwd, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_modify_success'),
              type: 'success',
            });
            this.$emit('success');
            this.closeDialog();
          });
        } else {
          this.$postJSON(apis.bootCardChangeUser, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_modify_success'),
              type: 'success',
            });
            this.$emit('success');
            this.closeDialog();
          });
        }

        // this.$message({
        //   message: '修改成功',
        //   type: 'success'
        // });
      });
    },
  },
};
</script>

<style lang="scss"></style>
